import { render } from "./NetworkLobby.vue?vue&type=template&id=4de56d0b&ts=true"
import script from "./NetworkLobby.vue?vue&type=script&lang=ts"
export * from "./NetworkLobby.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/NetworkLobby.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4de56d0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4de56d0b', __exports__)) {
    api.reload('4de56d0b', __exports__)
  }
  
  module.hot.accept("./NetworkLobby.vue?vue&type=template&id=4de56d0b&ts=true", () => {
    api.rerender('4de56d0b', render)
  })

}


export default __exports__